module.exports = __webpack_public_path__ + "img/ic_serve_bottom_right_img.8d6e1eb5.png";